import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const NebraskaMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg
			id='nebraska'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1000 1000'
			className='map'>
			<polygon
				id='NE_ZS'
				points='310.83 551.6 304.65 683.01 581.53 693.58 941.96 693.58 931.04 667.06 910.75 644.43 901.39 620.25 892.03 588.26 890.92 566.05 310.83 551.6'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'NE_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('NE_ZS')}
			/>
			<polygon
				id='NE_ZN'
				points='890.92 566.05 888.91 525.85 883.45 509.47 867.84 495.43 860.82 453.3 833.52 375.29 822.6 370.16 798.41 347.98 783.14 344.47 750.04 329.26 708.7 329.26 697.34 340.96 686.85 340.96 665.01 330.04 649.5 310.54 544.87 310.54 357.64 303.52 139.12 292.5 121.26 543.02 310.83 551.6 890.92 566.05'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'NE_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('NE_ZN')}
			/>
			<rect
				x='423.64'
				y='594.09'
				width='59.85'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M423.02,633.61l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M457.51,630.43c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect
				x='409.68'
				y='364.94'
				width='73.15'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M409.06,404.47l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M442.93,407.54l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<polygon
				points='864.49 498.82 864.6 503.14 869.15 503.14 864.67 505.82 864.78 510.14 861.9 507.47 857.42 510.14 860.12 505.82 857.25 503.14 861.79 503.14 864.49 498.82'
				className='shape'
			/>
			<rect x='774.24' y='481.74' width='84.43' height='20' fill='none' className='shape' />
			<path
				d='M790.03,488.97c0,2.8-1.03,5.9-2.95,7.81-1.43,1.42-3.31,2.26-5.54,2.26-4.18,0-6.13-3.15-6.13-6.58,0-2.84,1.11-6,3.08-7.93,1.39-1.35,3.38-2.19,5.42-2.19,4.35,0,6.12,3.17,6.12,6.63ZM779.95,485.64c-1.56,1.56-2.46,4.4-2.46,6.66,0,2.63,1.17,5.06,4.33,5.06,1.38,0,2.69-.6,3.69-1.62,1.53-1.53,2.41-4.44,2.41-6.69s-.75-5.04-4.29-5.04c-1.44,0-2.7.63-3.7,1.62Z'
				className='shape'
			/>
			<path
				d='M793.53,498.78l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.75l-.31,2.18h.06c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.26-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.3,6.85h-1.94l1.25-6.69c.08-.45.17-1.03.17-1.52,0-1.23-.46-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.83h-1.94Z'
				className='shape'
			/>
			<path
				d='M823.04,498.78c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM824.33,488.66c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M830.29,498.78l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<path
				d='M853.23,498.78c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM854.52,488.66c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<polygon
				points='763.38 589.27 763.49 593.59 768.03 593.59 763.55 596.26 763.66 600.59 760.79 597.92 756.31 600.59 759.01 596.26 756.13 593.59 760.68 593.59 763.38 589.27'
				className='shape'
			/>
			<rect x='673.13' y='572.19' width='84.43' height='20' fill='none' className='shape' />
			<path
				d='M676.96,573.05h1.99l-2.76,14.45h6.53l-.33,1.73h-8.5l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M686.84,589.23l2.22-11.61h1.99l-2.22,11.61h-1.99ZM689.43,574.38c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M694.76,589.23l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.48,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M717.99,588.77c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.03-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.11,2.89,3.11,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M733.5,582.19c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.15-4.53-4.77,0-3.84,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM724.57,584.65c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path d='M737.32,589.23l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M745.23,589.23l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.48,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<polygon
				points='612.07 589.93 612.18 594.26 616.73 594.26 612.25 596.93 612.35 601.25 609.48 598.58 605 601.25 607.7 596.93 604.82 594.26 609.37 594.26 612.07 589.93'
				className='shape'
			/>
			<rect x='513.94' y='572.86' width='92.31' height='20' fill='none' className='shape' />
			<path
				d='M517.76,573.72h1.97l-1.49,7.87h.1c.56-.71,1.1-1.27,1.6-1.83l5.69-6.04h2.49l-6.81,6.96,4.15,9.22h-2.16l-3.54-7.94-1.93,1.8-1.18,6.14h-1.97l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M537.58,589.23c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.43,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM535.38,579.57c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M550.2,589.9c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM551.49,579.77c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M557.51,589.9l1.42-7.48c.29-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M567.54,589.9l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M591.15,589.23c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.43,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM588.95,579.57c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M598.68,578.29l1.15,6.24c.26,1.34.41,2.19.52,3.06h.06c.31-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.17,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.25-2.68.1-.19.09-.32.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
			<polygon
				points='433.11 534.13 433.21 538.45 437.76 538.45 433.28 541.13 433.39 545.45 430.51 542.78 426.03 545.45 428.73 541.13 425.86 538.45 430.4 538.45 433.11 534.13'
				className='shape'
			/>
			<rect x='437.28' y='517.05' width='145.96' height='20' fill='none' className='shape' />
			<path
				d='M438.03,534.09l3.08-16.18h2.18l3.71,9.16c.72,1.84,1.08,3.12,1.42,4.51l.05-.03c.09-1.45.26-2.8.68-5.06l1.63-8.58h1.88l-3.08,16.18h-1.97l-3.69-9.14c-.79-2-1.15-3.13-1.5-4.67l-.07.02c-.18,1.51-.44,3.13-.85,5.33l-1.6,8.46h-1.88Z'
				className='shape'
			/>
			<path
				d='M466.69,527.05c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM457.77,529.51c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M470.51,534.09l1.42-7.48c.29-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M486.38,519.37l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.08-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M491.12,534.09l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.81h-1.99Z'
				className='shape'
			/>
			<path
				d='M516.25,518.15c.91-.21,2.2-.35,3.5-.35,1.56,0,3.06.38,3.96,1.25.76.71,1.17,1.65,1.17,2.93,0,1.81-.88,3.33-1.94,4.21-1.25,1.05-3.08,1.55-4.9,1.55-.61,0-1.14-.04-1.65-.13l-1.23,6.48h-1.96l3.04-15.94ZM516.72,525.93c.57.12,1.02.16,1.61.16,2.73,0,4.56-1.7,4.56-3.97,0-1.93-1.38-2.69-3.22-2.69-.79,0-1.39.07-1.74.17l-1.21,6.33Z'
				className='shape'
			/>
			<path d='M527.63,534.09l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M543.24,534.09c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.5,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM544.53,523.97c-.28-.09-.71-.17-1.38-.17-3,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M555.71,519.37l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M565.65,519.37l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.08-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M578.67,533.43c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.24,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM576.46,523.77c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.76-1.48Z'
				className='shape'
			/>
			<polygon
				points='164.06 464.96 164.16 469.28 168.71 469.28 164.23 471.95 164.34 476.28 161.46 473.6 156.98 476.28 159.68 471.95 156.81 469.28 161.35 469.28 164.06 464.96'
				className='shape'
			/>
			<rect x='166.48' y='474.07' width='77.09' height='20' fill='none' className='shape' />
			<path
				d='M179.13,490.42c-.94.37-2.66.86-4.56.86-2.28,0-4.06-.65-5.29-2.02-1.23-1.35-1.63-3.12-1.63-4.72,0-2.68,1.09-5.49,3.16-7.36,1.73-1.52,4.06-2.4,6.65-2.4,1.99,0,3.33.45,3.82.74l-.66,1.68c-.82-.42-1.94-.7-3.4-.7-1.9,0-3.66.71-5.01,1.97-1.51,1.41-2.43,3.73-2.43,5.92,0,3.12,1.57,5.19,5.16,5.19.96,0,1.87-.19,2.46-.46l.92-4.83h-3.27l.31-1.63h5.23l-1.46,7.77Z'
				className='shape'
			/>
			<path
				d='M192.98,490.45c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM190.78,480.79c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M197.9,491.11l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M207.94,491.11l2.22-11.61h1.99l-2.22,11.61h-1.99ZM210.52,476.26c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.79-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M215.85,491.11l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M231.2,493.75c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM240.12,481.23c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<polygon
				points='890.26 617.61 890.37 621.94 894.92 621.94 890.44 624.61 890.55 628.93 887.67 626.26 883.19 628.93 885.89 624.61 883.02 621.94 887.56 621.94 890.26 617.61'
				className='shape'
			/>
			<rect x='722.02' y='630.54' width='162.42' height='20' fill='none' className='shape' />
			<path
				d='M722.77,647.58l3.08-16.18h2.18l3.71,9.16c.72,1.84,1.08,3.12,1.42,4.51l.05-.03c.09-1.45.26-2.8.68-5.06l1.63-8.58h1.88l-3.08,16.18h-1.97l-3.69-9.14c-.79-2-1.15-3.13-1.5-4.67l-.07.02c-.18,1.51-.44,3.13-.85,5.33l-1.6,8.46h-1.88Z'
				className='shape'
			/>
			<path
				d='M748.67,646.91c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM746.47,637.25c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M758.71,630.54l-1.53,7.54h.05c1.03-1.55,2.52-2.37,4.08-2.37,2.54,0,3.52,2.1,3.52,4.16,0,3.57-2.58,7.98-7.23,7.98-2.04,0-3.58-.85-3.58-3,0-.57.1-1.25.2-1.8l2.5-12.51h1.99ZM756.19,643.09c-.08.39-.15.86-.14,1.47.01,1.1.64,1.71,1.88,1.71,3.01,0,4.82-3.57,4.82-6.15,0-1.44-.63-2.77-2.22-2.77-1.71,0-3.5,1.78-4.08,4.5l-.26,1.23Z'
				className='shape'
			/>
			<path
				d='M768.62,647.58l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M786.01,647.58c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM787.3,637.46c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M793.41,645.56c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M804.69,647.58l3.24-17.04h1.98l-2.04,10.68h.05c.35-.41.78-.85,1.09-1.17l4.09-4.08h2.46l-5.06,4.76,3.47,6.84h-2.19l-2.79-5.73-1.47,1.31-.83,4.42h-1.98Z'
				className='shape'
			/>
			<path
				d='M825.42,647.58c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM826.71,637.46c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M850.71,647.05c-.91.41-2.38.77-4.2.77-4.07,0-6.57-2.59-6.57-6.72,0-3.05,1.23-5.95,3.45-7.8,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M855.18,647.58l2.22-11.61h1.99l-2.22,11.61h-1.99ZM857.77,632.73c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M868.3,632.85l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M875.84,635.97l1.15,6.24c.26,1.34.41,2.19.52,3.06h.06c.31-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.17,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.24-2.68.1-.19.09-.32.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
		</svg>
	);
};

NebraskaMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default NebraskaMap;
